import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
export interface BlogPostItemProps {
  id: string;
  imageSrc: string;
  title: string;
  date?: string;
  content: string;
  sefUrl: string;
  readmore?: string;
}

const BlogPostItem: React.FC<any> = ({ id, image, title, date, content, sefUrl , readmore}) => {
  return (
    <li>
      <i className="post-icon img-circle fa fa-picture-o"></i>
      <article className="blog2-item">
        <div className="blog2-thumbnail" style={{ width: '96px', height: '96px', overflow: 'hidden' }}>
          <img src={image} alt={title} style={{ width: 'auto', height: '100%' }} />
        </div>
        <div className="blog2-content">
          <span className="arrow-right"></span>
          <h4 className="blog2-title">
            <Link className="read-more" to={`${sefUrl}`}>
              {title}
            </Link>
          </h4>
          {date && <p className="post-date">{moment(date).format('DD MMMM YYYY')}</p>}
          <p>
            <span>
              {content.replace(/<\/?[^>]+(>|$)/g, '').length > 80
                ? `${content.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 80)}... `
                : content.replace(/<\/?[^>]+(>|$)/g, '')}
            </span>

            <Link className="read-more" to={`${sefUrl}`}>
              {readmore}
            </Link>
          </p>
        </div>
      </article>
    </li>
  );
};

export default BlogPostItem;
